import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import GoBack from "../../../component/molecules/goBack";
import { errorHandler } from "../../../util/errorHandler";
import FreePdfApplyApi from "../../../api/freePdfApply.api";

const UserPDFApplicationListDetail = () => {
  let { id } = useParams();

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUserInfoFunc = async () => {
    try {
      const response = (await FreePdfApplyApi.getDetail(id)).data.data.content;
      console.log(response);
      setUserInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                무료 PDF 신청 명단
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 이름 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name || "-"}</DetailFormText>
                </DetailPageForm>
                {/* 아이디(이메일) */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이메일
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email || "-"}</DetailFormText>
                </DetailPageForm>
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default UserPDFApplicationListDetail;
